import React from 'react';
import styles from '$modules/onboarding/module-components/sign-in/signIn.module.scss';
import { SubHeader } from '@brahma/components';
import { validIcons } from '@brahma/components';
import useLocale from '$hooks/use-locale';
import { ONBOARDING } from '$locale/constants';
import useGlobalContext from '$hooks/use-global-context';
const SubHeaderSignIn = () => {
  const {
    t
  } = useLocale(ONBOARDING);
  const {
    state: layout
  } = useGlobalContext();
  return <div className={styles.subheaderContainer} data-sentry-component="SubHeaderSignIn" data-sentry-source-file="subHeader.tsx">
      <SubHeader iconName={validIcons.dfgLogoSmall} title={layout.screen.isMobile ? t('signIn.mobile.title') : t('signIn.web.title')} description={layout.screen.isMobile ? t('signIn.mobile.description') : t('signIn.web.description')} iconClassName={layout.screen.isMobile ? undefined : styles.iconHeaderStyle} iconWidth={layout.screen.isMobile ? '64px' : '50px'} background="gridDotLg" baseUrl={process.env.NEXT_PUBLIC_STATIC_URL ?? ''} className={styles.subHeader} showHeaderLogo={!layout?.coBrandDetails?.carousal?.length} data-sentry-element="SubHeader" data-sentry-source-file="subHeader.tsx" />
    </div>;
};
export default SubHeaderSignIn;